import { Button, FormControl, Stack, TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Bounce, toast, ToastContainer } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { getParticipantEmailAsync, GetSingleWorkoutAsync, selectSingleParticipantEmail, selectSingleWorkout, SelfRemoveParticipantAsync } from '../features/add_workout/workoutSlice';
import { changeDateFormat } from '../app/consts';
import emailjs from '@emailjs/browser'

const CancelRegistration = () => {
  const dispatch = useAppDispatch();
  let workoutId = useParams().workoutId;
  let uniqueId = useParams().id;
  const inputRefs = useRef<any[]>([]);

  const [PhoneNum, setPhoneNum] = useState<string>();
  const [PersonalId, setPersonalId] = useState<string>();
  const [PhoneNumberNotValid, setPhoneNumberNotValid] = useState<boolean>();
  const [PersonalIdNotValid, setPersonalIdNotValid] = useState<boolean>();
  const [otp, setOtp] = useState<string[]>(new Array(6).fill([]));
  const [IsReadyForOTP, setIsReadyForOTP] = useState<boolean>();
  const [code, setCode] = useState<number>(0)
  const [PhoneNumberHelper, setPhoneNumberHelper] = useState('')
  const [PersonalIdHelper, setPersonalIdHelper] = useState('')
  

  const currentWorkout = useAppSelector(selectSingleWorkout);
  const email = useAppSelector(selectSingleParticipantEmail);

  emailjs.init("y7dwm07pNohWq81rU");

  useEffect(() => {
    setCode(Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000)
  }, [uniqueId])


  const validatePhoneNumber = (phoneNum: string) => {
    const reg = new RegExp("^05\\d{8}$");
    if (reg.test(phoneNum) === false) {
      setPhoneNumberNotValid(true)
    }
    else {
      setPhoneNumberNotValid(false)
      setPhoneNum(phoneNum)
    }
    setPhoneNumberHelper("מספר הטלפון חייב להתחיל ב-05 ולהכיל בדיוק 10 ספרות")

  }

  const validatePersonalId = (personalId: string) => {
    const reg = new RegExp("^\\d{9}$");
    if (reg.test(personalId) === false) {
      setPersonalIdNotValid(true)
    }
    else {
      setPersonalIdNotValid(false)
      setPersonalId(personalId)
    }
    setPersonalIdHelper("ת.ז חייב להכיל 9 ספרות בלבד")

  }

  const createData = (start: boolean) => {
    const temp = { "workoutId": +(workoutId as string), "uId": uniqueId as string, 'personalId': PersonalId as string, "phoneNum": PhoneNum as string, "start": start };
    return temp
  }

  const handleSubmit = () => {
    let Errors = document.querySelector<HTMLInputElement>('form[id="cancelRegistration"]')?.checkValidity();
    if (!Errors)
      toast.error("קיימת טעות/חסר מידע בטופס");
    else {
      const temp = createData(false);
      dispatch(SelfRemoveParticipantAsync(temp)).unwrap()
        .then(() => {
          emailjs.send("service_1qd2ez8", "template_64ap4yc", {
            subject: "קוד חד פעמי לביטול רישום",
            email: email,
            msg: `
התקבלה בקשה לביטול רישום לאימון,
בכדי להמשיך בתהליך, אנא הזן את הקוד הבא במערכת:
${code?.toString()}
אם לא ביקשת לבצע את ביטול הרישום, יש להתעלם מהודעה זאת
            `,
            isRegister: false //registration links wil be hidden
          });
          const form = document.getElementById('cancelRegistration') as HTMLFormElement;
          form.reset();
          setIsReadyForOTP(true)
        })
        .catch(() => {
          toast.error("אירעה שגיאה, נסה שנית");
          return
        })
    }
  }

  const handleDone = () => {
    const temp = createData(true)
    const userCodeInput = otp.join("")
    if (code?.toString() === userCodeInput) {
      dispatch(SelfRemoveParticipantAsync(temp)).unwrap()
        .then(() => {
          setIsReadyForOTP(false);
          toast.success('הרישום הוסר בהצלחה');
        })
        .catch((err)=>console.error("Handled error:", err))
      setTimeout(() => {
        window.location.reload()
      }, 5500);
    }
    else {
      toast.error("הקוד לא תואם, נסה שנית");
    }
  }

  const handleChange = (e: any, index: number) => {
    const value = e.target.value;
    if (isNaN(value)) return; // Only allow numeric input

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // Take only the last character entered
    setOtp(newOtp);

    // Move focus to the next input if a digit is entered
    if (value && index < 6 - 1) {
      inputRefs.current[index + 1].focus();
      inputRefs.current[index + 1].select();
    }
  };

  const handleKeyDown = (e: any, index: number) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      // Move focus to the previous input on backspace if current is empty
      inputRefs.current[index - 1].focus();
      inputRefs.current[index - 1].select();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault(); // stop default paste into one field
    const paste = e.clipboardData.getData('text').trim();

    if (!/^\d+$/.test(paste)) return;

    const digits = paste.slice(0, 6).split('');
    const newOtp = Array(6).fill('');
    digits.forEach((digit, i) => {
      newOtp[i] = digit;
    });
    setOtp(newOtp);

    // move focus to the last filled box
    const lastIndex = Math.min(digits.length, 6) - 1;
    inputRefs.current[lastIndex]?.focus();
    inputRefs.current[lastIndex]?.select();
  };


  useEffect(() => {
    dispatch(GetSingleWorkoutAsync(workoutId as string)).unwrap().catch((err)=>console.error("Handled error:", err))
    dispatch(getParticipantEmailAsync({ "workoutId": workoutId as string, "uId": uniqueId as string })).unwrap().catch((err)=>console.error("Handled error:", err))
    // eslint-disable-next-line
  }, [])

  return (
    <div style={{ margin: 'auto', textAlign: 'center', marginTop: '2%' }}>
      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      {email ?
        <>
          <h1>ביטול הרשמה לאימון</h1>
          אנא הזדהה עם תעודת זהות וטלפון נייד שתואמים לפרטים שנמסרו במעמד ההזמנה<br /><br />
          פרטי האימון לביטול:<br />
          {currentWorkout?.type?.name === undefined ?
            <>
              הנתונים בטעינה אנא המתן <br />
            </>
            :
            <>
              סוג האימון: {currentWorkout.type?.name}<br />
              תאריך: {changeDateFormat(currentWorkout?.date)}<br />
              שעת התחלה: {currentWorkout?.time.slice(0, -3)}<br />
              מדריך: {currentWorkout.instructor?.fullName}<br />
              מיקום: {currentWorkout?.location}<br />
            </>
          }
          <br /><br />
          {IsReadyForOTP ?
            <div>
              קוד חד פעמי נשלח לכתובת הדואר האלקטרוני שהזנת במעמד ההרשמה.<br />
              אנא הזן את הקוד ולחץ על הכפתור המשך<br /><br /><br /><br />
              <Stack direction="row-reverse" sx={{ justifyContent: "center", alignItems: "center", }}>
                {otp.map((digit, index) => (
                  <TextField
                    key={index}
                    inputRef={(el) => (inputRefs.current[index] = el)}
                    value={digit}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onPaste={handlePaste}
                    slotProps={{
                      htmlInput:{
                      maxLength: 1,
                      style: { textAlign: 'center' },
                      inputMode: 'numeric', // Show numeric keyboard on mobile
                      autoComplete: 'one-time-code', // Suggest OTP on iOS
                      }
                    }}
                    variant="standard"
                    sx={{ marginLeft: 2 }}
                  />
                ))}
              </Stack><br /><br /><br /><br />
              <Button id='submit' type='submit' onClick={() => handleDone()} variant="contained" size='large' color='info'>המשך</Button>
            </div>
            :
            <form method='POST' id='cancelRegistration' onSubmit={(e) => e.preventDefault()}>
              <FormControl>
                <TextField variant="filled" label='תעודת זהות' type='text' onChange={(e) => validatePersonalId(e.target.value)} error={PersonalIdNotValid} helperText={PersonalIdHelper} required style={{ textAlign: 'center', width: '300px', }} /><br />
                <TextField variant="filled" label='מספר טלפון נייד' type='tel' onChange={(e) => validatePhoneNumber(e.target.value)} error={PhoneNumberNotValid} helperText={PhoneNumberHelper} required style={{ textAlign: 'center', width: '300px', }} /><br />
                <Button id='submit' type='submit' onClick={() => { handleSubmit() }} variant="contained" size='large' color='error'>בטל הרשמה לאימון זה</Button>
              </FormControl>
            </form>
          }
        </>
        :
        <h1>
          המשתמש לא רשום לאימון זה
        </h1>
      }
    </div>
  )
}

export default CancelRegistration